export default __webpack_public_path__ + "static/media/Averta-Semibold.5151187c.woff";